<template>
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-12 col-lg-10">
        <h1>Justificativas de cancelamento</h1>

        <p class="intro">
          Consulte solicitações de cancelamento e acompanhe todos os registros.
        </p>
      </div>

      <!-- FILTROS -->
      <div class="col-12 col-lg-10">
        <div class="filtros-status">
          <button
            v-for="filtro in filtros"
            :key="filtro.value"
            class="filtro-btn"
            :class="{
              ativo: filtroAtual === filtro.value
            }"
            @click="selecionarFiltro(filtro.value)"
          >
            {{ filtro.label }}
          </button>
        </div>

        <!-- FILTROS AVANÇADOS -->
        <div class="filtros-avancados">
          <div class="row">
            <div class="col-12 col-md-3">
              <label class="form-label">
                Período
              </label>

              <select
                v-model="filtroPeriodo"
                class="form-select"
              >
                <option value="todos">
                  Todo período
                </option>

                <option value="hoje">
                  Hoje
                </option>

                <option value="7dias">
                  Últimos 7 dias
                </option>

                <option value="30dias">
                  Últimos 30 dias
                </option>

                <option value="personalizado">
                  Personalizado
                </option>
              </select>
            </div>

            <div
              class="col-12 col-md-3"
              v-if="
                filtroPeriodo
                === 'personalizado'
              "
            >
              <label class="form-label">
                Data inicial
              </label>

              <input
                v-model="dataInicial"
                type="date"
                class="form-control"
              >
            </div>

            <div
              class="col-12 col-md-3"
              v-if="
                filtroPeriodo
                === 'personalizado'
              "
            >
              <label class="form-label">
                Data final
              </label>

              <input
                v-model="dataFinal"
                type="date"
                class="form-control"
              >
            </div>

            <div class="col-12 col-md-3">
              <label class="form-label">
                Ordenação
              </label>

              <select
                v-model="ordenacao"
                class="form-select"
              >
                <option value="desc">
                  Mais recentes
                </option>

                <option value="asc">
                  Mais antigos
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>

      <!-- BUSCA -->
      <div class="col-12 col-lg-10">
        <form
          class="search-box"
          @submit.prevent="buscarCancelamentos"
        >
          <label
            for="filtroBid"
            class="form-label"
          >
            Pesquisar por ticket (`bid`)
          </label>

          <div class="input-group">
            <input
              id="filtroBid"
              v-model.trim="filtroBid"
              type="text"
              class="form-control"
              placeholder="Ex.: 24082110301501"
            >

            <button
              type="submit"
              class="btn btn-primary"
              :disabled="isLoadingBusca"
            >
              {{
                isLoadingBusca
                  ? "Consultando..."
                  : "Buscar"
              }}
            </button>

            <button
              type="button"
              class="btn btn-outline-secondary"
              :disabled="isLoadingBusca"
              @click="limparBusca"
            >
              Limpar
            </button>
          </div>
        </form>
      </div>

      <!-- ALERTAS -->
      <div class="col-12 col-lg-10">
        <div
          v-if="mensagemInfo"
          class="alert alert-info"
        >
          {{ mensagemInfo }}
        </div>

        <div
          v-if="erroBusca"
          class="alert alert-danger"
        >
          {{ erroBusca }}
        </div>

        <div
          v-if="erroRecentes"
          class="alert alert-danger"
        >
          {{ erroRecentes }}
        </div>
      </div>

      <!-- RESULTADO BUSCA -->
      <div
        class="col-12 col-lg-10"
        v-if="
          buscaExecutada
          && resultadoBusca.length
        "
      >
        <h2 class="section-title">
          Resultado da pesquisa
        </h2>

        <div
          v-for="(cancelamento, index) in resultadoBusca"
          :key="`busca-${cancelamento.bid}-${index}`"
          class="resultado-card"
        >
          <div class="resultado-header">
            <div>
              <h2>
                Ticket {{ cancelamento.bid }}
              </h2>

              <p class="mb-0">
                <b>Status:</b>

                {{
                  obterStatus(
                    cancelamento.estadoaprovacao
                  )
                }}
              </p>
            </div>

            <span
              class="badge-status"
              :class="
                classeStatus(
                  cancelamento.estadoaprovacao
                )
              "
            >
              {{
                obterStatus(
                  cancelamento.estadoaprovacao
                )
              }}
            </span>
          </div>

          <div class="row text-start">
            <div class="col-12 col-md-6">
              <p>
                <b>E-mail:</b>

                {{
                  cancelamento.emailcancelamento
                  || cancelamento.email
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Instituição:</b>

                {{
                  cancelamento.instituicao
                  || "Não informado"
                }}
              </p>

              <p>
                <b>CNPJ:</b>

                {{
                  cancelamento.cnpj
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Solicitado em:</b>

                {{
                  formatarData(
                    cancelamento.criado_em
                  )
                }}
              </p>
            </div>

            <div class="col-12 col-md-6">
              <p>
                <b>Roteiro:</b>

                {{
                  extrairoteiro(
                    cancelamento.idbruto
                  )
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Responsável:</b>

                {{
                  cancelamento.nomecontato
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Telefone/Contato:</b>

                {{
                  cancelamento.obs
                  || cancelamento.obswp
                  || "Não informado"
                }}
              </p>
            </div>

            <div class="col-12">
              <div class="justificativa-box">
                <b>Justificativa</b>

                <p>
                  {{
                    cancelamento.justificativa
                    || "Sem justificativa registrada."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- LISTA -->
      <div
        class="col-12 col-lg-10"
        v-if="!buscaExecutada"
      >
        <h2 class="section-title">
          Cancelamentos
        </h2>

        <div
          v-for="(cancelamento, index) in cancelamentosFiltrados"
          :key="`lista-${cancelamento.bid}-${index}`"
          class="resultado-card"
        >
          <div class="resultado-header">
            <div>
              <h2>
                Ticket {{ cancelamento.bid }}
              </h2>

              <p class="mb-0">
                <b>Status:</b>

                {{
                  obterStatus(
                    cancelamento.estadoaprovacao
                  )
                }}
              </p>
            </div>

            <span
              class="badge-status"
              :class="
                classeStatus(
                  cancelamento.estadoaprovacao
                )
              "
            >
              {{
                obterStatus(
                  cancelamento.estadoaprovacao
                )
              }}
            </span>
          </div>

          <div class="row text-start">
            <div class="col-12 col-md-6">
              <p>
                <b>E-mail:</b>

                {{
                  cancelamento.emailcancelamento
                  || cancelamento.email
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Instituição:</b>

                {{
                  cancelamento.instituicao
                  || "Não informado"
                }}
              </p>

              <p>
                <b>CNPJ:</b>

                {{
                  cancelamento.cnpj
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Solicitado em:</b>

                {{
                  formatarData(
                    cancelamento.criado_em
                  )
                }}
              </p>
            </div>

            <div class="col-12 col-md-6">
              <p>
                <b>Roteiro:</b>

                {{
                  extrairoteiro(
                    cancelamento.idbruto
                  )
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Responsável:</b>

                {{
                  cancelamento.nomecontato
                  || "Não informado"
                }}
              </p>

              <p>
                <b>Telefone/Contato:</b>

                {{
                  cancelamento.obs
                  || cancelamento.obswp
                  || "Não informado"
                }}
              </p>
            </div>

            <div class="col-12">
              <div class="justificativa-box">
                <b>Justificativa</b>

                <p>
                  {{
                    cancelamento.justificativa
                    || "Sem justificativa registrada."
                  }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="
            !cancelamentosFiltrados.length
            && !isLoadingRecentes
          "
          class="alert alert-secondary"
        >
          Nenhum registro encontrado.
        </div>

        <div
          class="d-flex justify-content-center mt-4"
          v-if="temMaisRecentes"
        >
          <button
            class="btn btn-outline-primary"
            @click="carregarMais"
            :disabled="isLoadingRecentes"
          >
            {{
              isLoadingRecentes
                ? "Carregando..."
                : "Carregar mais 20"
            }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  computed,
  onMounted,
  ref,
} from "vue";

import axios from "axios";

export default {
  setup() {
    const filtroBid = ref("");

    const resultadoBusca = ref([]);

    const cancelamentosRecentes = ref([]);

    const isLoadingBusca = ref(false);

    const isLoadingRecentes = ref(false);

    const erroBusca = ref("");

    const erroRecentes = ref("");

    const mensagemInfo = ref(
      "Utilize os filtros abaixo para gerenciar os cancelamentos."
    );

    const buscaExecutada = ref(false);

    const paginaAtual = ref(0);

    const tamanhoPagina = 20;

    const temMaisRecentes = ref(true);

    const filtroAtual = ref("todos");

    const filtroPeriodo = ref("todos");

    const dataInicial = ref("");

    const dataFinal = ref("");

    const ordenacao = ref("desc");

    const filtros = [
      {
        label: "Todos",
        value: "todos",
      },
      {
        label: "Solicitados",
        value: "solicitado",
      },
      {
        label: "Cancelados",
        value: "cancelado",
      },
    ];

    const selecionarFiltro = (
      filtro
    ) => {
      filtroAtual.value = filtro;
    };

    const cancelamentosFiltrados = computed(() => {
      let registros = [
        ...cancelamentosRecentes.value,
      ];

      // STATUS
      registros = registros.filter(
        (cancelamento) => {
          const estado = String(
            cancelamento.estadoaprovacao
          );

          switch (filtroAtual.value) {
            case "solicitado":
              return estado === "4";

            case "cancelado":
              return estado === "0";

            default:
              return true;
          }
        }
      );

      // PERÍODO
      const hoje = new Date();

      registros = registros.filter(
        (cancelamento) => {
          if (
            !cancelamento.criado_em
          ) {
            return true;
          }

          const dataRegistro =
            new Date(
              cancelamento.criado_em
            );

          switch (
            filtroPeriodo.value
          ) {
            case "hoje": {
              return (
                dataRegistro.toDateString()
                === hoje.toDateString()
              );
            }

            case "7dias": {
              const seteDias =
                new Date();

              seteDias.setDate(
                hoje.getDate() - 7
              );

              return (
                dataRegistro
                >= seteDias
              );
            }

            case "30dias": {
              const trintaDias =
                new Date();

              trintaDias.setDate(
                hoje.getDate() - 30
              );

              return (
                dataRegistro
                >= trintaDias
              );
            }

            case "personalizado": {
              if (
                !dataInicial.value
                || !dataFinal.value
              ) {
                return true;
              }

              const inicio =
                new Date(
                  dataInicial.value
                );

              const fim =
                new Date(
                  dataFinal.value
                );

              fim.setHours(
                23,
                59,
                59,
                999
              );

              return (
                dataRegistro >= inicio
                && dataRegistro <= fim
              );
            }

            default:
              return true;
          }
        }
      );

      // ORDENAÇÃO
      registros.sort(
        (a, b) => {
          const dataA =
            new Date(a.criado_em);

          const dataB =
            new Date(b.criado_em);

          if (
            ordenacao.value
            === "asc"
          ) {
            return dataA - dataB;
          }

          return dataB - dataA;
        }
      );

      return registros;
    });

    const formatarData = (
      dataISO
    ) => {
      if (!dataISO) {
        return "Não informado";
      }

      const data = new Date(dataISO);

      if (
        Number.isNaN(
          data.getTime()
        )
      ) {
        return dataISO;
      }

      return `${data.toLocaleDateString(
        "pt-BR"
      )} ${data.toLocaleTimeString(
        "pt-BR",
        {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        }
      )}`;
    };

    const extrairoteiro = (
      ide
    ) => {
      if (!ide) {
        return "";
      }

      const regex =
        /(\d{4})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/;

      const match =
        ide.match(regex);

      if (!match) {
        return ide;
      }

      const year =
        parseInt(
          match[1],
          10
        );

      const month =
        parseInt(
          match[2],
          10
        );

      const day =
        parseInt(
          match[3],
          10
        );

      const date =
        new Date(
          year,
          month - 1,
          day
        );

      const dayOfWeek =
        date.getDay();

      const daysOfWeek = [
        "Domingo",
        "Segunda-feira",
        "Terça-feira",
        "Quarta-feira",
        "Quinta-feira",
        "Sexta-feira",
        "Sábado",
      ];

      const dayName =
        daysOfWeek[
          dayOfWeek
        ];

      const isJuly2024 =
        year === 2024
        && month === 7;

      const isWeekend =
        dayOfWeek === 6
        || dayOfWeek === 0;

      if (
        match[7] === "14"
        || isJuly2024
        || isWeekend
        || ide.endsWith("f")
      ) {
        return ide.replace(
          regex,
          `Roteiro Livre - posição: $7 | $4h$5 | $3/$2/$1 (${dayName})`
        );
      }

      return ide.replace(
        regex,
        `Roteiro $7 | $4h$5 | $3/$2/$1 (${dayName})`
      );
    };

    const obterStatus = (
      status
    ) => {
      switch (
        String(status)
      ) {
        case "0":
          return "Cancelado";

        case "4":
          return "Solicitado";

        default:
          return "Em análise";
      }
    };

    const classeStatus = (
      status
    ) => {
      switch (
        String(status)
      ) {
        case "0":
          return "badge-cancelado";

        case "4":
          return "badge-pendente";

        default:
          return "badge-default";
      }
    };

    const buscarCancelamentos =
      async () => {
        if (
          !filtroBid.value
        ) {
          erroBusca.value =
            "Informe o ticket.";

          resultadoBusca.value =
            [];

          buscaExecutada.value =
            false;

          return;
        }

        isLoadingBusca.value =
          true;

        erroBusca.value = "";

        try {
          const response =
            await axios.post(
              "https://museucatavento.org.br/sistema-agendamento/api_cancelamentos.php",
              {
                bid: filtroBid.value,
              }
            );

          resultadoBusca.value =
            Array.isArray(
              response.data
            )
              ? response.data
              : [];
        } catch (error) {
          console.error(error);

          erroBusca.value =
            "Erro ao consultar.";
        } finally {
          buscaExecutada.value =
            true;

          isLoadingBusca.value =
            false;
        }
      };

    const carregarRecentes =
      async (
        reset = false
      ) => {
        if (reset) {
          paginaAtual.value = 0;

          cancelamentosRecentes.value =
            [];

          temMaisRecentes.value =
            true;
        }

        if (
          !temMaisRecentes.value
          && !reset
        ) {
          return;
        }

        isLoadingRecentes.value =
          true;

        erroRecentes.value = "";

        try {
          const payload = {
            limit:
              tamanhoPagina,

            offset:
              paginaAtual.value
              * tamanhoPagina,
          };

          const response =
            await axios.post(
              "https://museucatavento.org.br/sistema-agendamento/api_cancelamentos.php",
              payload
            );

          const novosRegistros =
            Array.isArray(
              response.data
            )
              ? response.data
              : [];

          if (reset) {
            cancelamentosRecentes.value =
              novosRegistros;
          } else {
            cancelamentosRecentes.value =
              [
                ...cancelamentosRecentes.value,
                ...novosRegistros,
              ];
          }

          temMaisRecentes.value =
            novosRegistros.length
            === tamanhoPagina;

          if (
            novosRegistros.length >
            0
          ) {
            paginaAtual.value += 1;
          }
        } catch (error) {
          console.error(error);

          erroRecentes.value =
            "Não foi possível carregar os registros.";
        } finally {
          isLoadingRecentes.value =
            false;
        }
      };

      const carregarMais =
      () => {
        carregarRecentes(
          false
        );
      };

    const limparBusca = () => {
      filtroBid.value = "";

      resultadoBusca.value = [];

      erroBusca.value = "";

      buscaExecutada.value =
        false;

      carregarRecentes(true);
    };

    onMounted(() => {
      carregarRecentes(true);
    });

    return {
      buscaExecutada,
      buscarCancelamentos,
      cancelamentosFiltrados,
      cancelamentosRecentes,
      carregarMais,
      classeStatus,
      dataFinal,
      dataInicial,
      erroBusca,
      erroRecentes,
      extrairoteiro,
      filtroAtual,
      filtroBid,
      filtroPeriodo,
      filtros,
      formatarData,
      isLoadingBusca,
      isLoadingRecentes,
      limparBusca,
      mensagemInfo,
      obterStatus,
      ordenacao,
      resultadoBusca,
      selecionarFiltro,
      temMaisRecentes,
    };
  },
};
</script>

<style lang="scss" scoped>
.section-title {
  text-align: left;
  margin: 8px 0 20px;
}

.intro {
  max-width: 760px;
  margin: 16px auto 32px;
}

.search-box {
  background: #f3f6f8;
  border: 1px solid #d8e1e6;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
  text-align: left;
}

.filtros-status {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 24px;
}

.filtros-avancados {
  background: #f8fafc;
  border: 1px solid #d8e1e6;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 24px;
}

.filtro-btn {
  border: 1px solid #d8e1e6;
  background: white;
  border-radius: 999px;
  padding: 10px 18px;
  transition: 0.2s ease;
  font-weight: 600;
  cursor: pointer;
}

.filtro-btn:hover {
  transform: translateY(-1px);
}

.filtro-btn.ativo {
  background: #0d6efd;
  color: white;
  border-color: #0d6efd;
}

.resultado-card {
  border: 1px solid #d7d7d7;
  border-left: 6px solid #c73d2b;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 20px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}

.resultado-header {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  align-items: flex-start;
  margin-bottom: 16px;
  text-align: left;
}

.badge-status {
  border-radius: 999px;
  padding: 8px 14px;
  font-weight: 700;
  white-space: nowrap;
}

.badge-pendente {
  background: #fff1cc;
  color: #6d5400;
}

.badge-cancelado {
  background: #ffe1e1;
  color: #8f0000;
}

.badge-default {
  background: #ececec;
  color: #444;
}

.justificativa-box {
  margin-top: 12px;
  background: #fff8f6;
  border: 1px solid #f0d1ca;
  border-radius: 10px;
  padding: 16px;
}

.justificativa-box p {
  margin: 8px 0 0;
  white-space: pre-wrap;
}

@media (max-width: 767px) {
  .resultado-header {
    flex-direction: column;
  }

  .search-box .input-group {
    flex-direction: column;
    gap: 12px;
  }

  .search-box .btn,
  .search-box .form-control {
    width: 100%;
  }

  .filtros-status {
    flex-direction: column;
  }
}
</style>
